module.exports = __webpack_public_path__ + "img/figure04_sp.647c93b2.png";